import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";

import DynamicElement from "%/dynamic-component-editor/classes/dynamic-element";

// Lazy store resolution: a module-scope import here closes a cycle
// (stores -> components -> mixins -> classes). See scripts/find-import-cycles.py.
// eslint-disable-next-line global-require
const useDynamicComponentEditorStore = (...args) => require("%/dynamic-component-editor/stores/dynamic-component-editor").default(...args);


export default class StaticLayoutDirection extends BaseOption {
  static label = "Layout Direction";
  static canSetAsVariable = false;

  static userInterfaceComponent = {
    component: inspectorTools.RADIO_BAR,
    props: {
      options: [
        {
          value: "horizontal",
          icon: "arrow-right-thin",
        },
        {
          value: "vertical",
          icon: "arrow-down-thin",
        },
        {
          value: "horizontal-wrap",
          icon: "arrow-turn-left-thin",
        },
      ],
      sideEffect: (value, identifier) => {
        const store = useDynamicComponentEditorStore();
        const [state, breakpoint] = store.activeState.split(":");
        const horizontalWrap = value === "" ? "wrap" : "nowrap";
        const context = {
          themeMode: store.themeMode,
          themeId: store.themeId,
          breakpoints: store.selectableBreakpoints,
        };

        const element = DynamicElement.get(identifier);
        element?.updateOption("layout-wrap", breakpoint, state, horizontalWrap, context);
        element?.updateOption("static-layout-direction", breakpoint, state, value, context);
      },
    },
  };

  static defaultValue = "vertical";
}
